/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {AdUnitModel} from './ad-unit-api.service';

@Component({
  standalone: false,
  selector: 'adn-ad-unit-item-page',
  template: `
    <adn-two-panel-layout>
      <adn-ad-unit-edit-page leftPanel [state]="state"></adn-ad-unit-edit-page>
      <adn-ad-unit-analysis-page rightPanel [state]="state" [model]="state.model()" [isNew]="state.isNew()"></adn-ad-unit-analysis-page>
    </adn-two-panel-layout>
  `
})
export class AdUnitItemPageComponent {
  @Input() state: SignalAdminResourcePageState<AdUnitModel>;
}
